import React, { lazy, Suspense } from "react";
import { Box } from "@mui/material";
import Navbar from "../widgets/navbar/navbar";
import MenuDrawer from "../../../Components/Widgets/MenuDrawer";
import SubMenuDrawer from "../../../Components/Widgets/SubMenuDrawer";
import Footer from "../widgets/footer";
import RevealSection from "../widgets/common/reveal-section";
import { HeroPlaceholder } from "../widgets/common/home-section-skeleton";
import { useTheme } from "@mui/material/styles";

const BannerHeroSlide = lazy(
  () => import("../../default/widgets/sliders/banner-hero-slide"),
);

const ExploreMoreSection = lazy(
  () => import("../../default/widgets/sliders/explore-more-section"),
);

const RecentlyViewed = lazy(
  () => import("../../../Components/Widgets/RecentlyViewed"),
);

const AllCollections = lazy(
  () => import("../../default/widgets/sliders/all-collections"),
);

const ExportDefault = (props) => {
  const theme = useTheme();
  const gap = { xs: 6, md: 8 };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
      }}
    >
      <Navbar bg_color="#fff" {...props} />
      <MenuDrawer {...props} />
      <SubMenuDrawer {...props} />
      <Suspense fallback={<HeroPlaceholder theme={theme} />}>
        <BannerHeroSlide
          {...{
            ...props,
            mb: gap,
            slide: {
              slug: "men-collections",
              imagesPath: "/marketing/main",
              smallSpacing: true,
              // title: "",
              // desc: "",
              // descMaxWidth: "640px",
              // buttons: [
              //   {
              //     name: "STACKABLE NECKLACES",
              //     url: "/women/type/necklace?curation=stacking",
              //   },
              //   {
              //     name: "STACKABLE RINGS",
              //     url: "/women/type/ring?curation=stacking",
              //   },
              // ],
            },
          }}
        />
      </Suspense>

      <RevealSection id="menCollections" variant="slider">
        <ExploreMoreSection
          {...{
            ...props,
            mb: gap,
            title: "LATEST MEN'S COLLECTIONS",
            imagesPath: "/marketing/main",
            buttons: [
              {
                name: "VIEW ALL",
                url: "/men/collectionS",
              },
            ],
            slides: [
              {
                slug: "kavafi-collection",
                url: "/men/collection/kavafi",
                buttons: [
                  {
                    name: "KAVAFI COLLECTION",
                    url: "/men/collection/kavafi",
                  },
                ],
                description:
                  "Explore stylish creations inspired by warrior armor from the Archaic and Hellenistic periods, designed in 18k gold with precious embedded stones.",
              },
              {
                slug: "kavos-collection",
                url: "/men/collection/kavos",
                buttons: [
                  {
                    name: "KAVOS COLLECTION",
                    url: "/men/collection/kavos",
                  },
                ],
                description:
                  "Discover nautical designs that echo Greek fishing ships and artful rope motifs.",
              },
              {
                slug: "alchemy-collection",
                url: "/men/collection/alchemy",
                buttons: [
                  {
                    name: "ALCHEMY COLLECTION",
                    url: "/men/collection/alchemy",
                  },
                ],
                description:
                  "Experience the captivating allure of intricately designed serpentine patterns that exude unique and irresistible charm.",
              },
              {
                slug: "hydra-collection",
                url: "/men/collection/hydra",
                buttons: [
                  {
                    name: "HYDRA COLLECTION",
                    url: "/men/collection/hydra",
                  },
                ],
                description:
                  "Discover designs that evoke hidden treasures, untold journeys, and timeless discovery.",
              },
              {
                slug: "laconia-collection",
                url: "/men/collection/laconia",
                buttons: [
                  {
                    name: "LACONIA COLLECTION",
                    url: "/men/collection/laconia",
                  },
                ],
                description:
                  "Explore a fresh wave of men’s designs inspired by ancient Spartan armor through emblematic engravings and motifs.",
              },
            ],
          }}
        />
      </RevealSection>

      <RevealSection id="allCollections" variant="slider">
        <AllCollections
          {...{
            ...props,
            mb: gap,
            gender: "men",
          }}
        />
      </RevealSection>

      <RevealSection id="recentlyViewed" variant="products">
        <RecentlyViewed
          {...props}
          mb={gap}
          title="ITEMS YOU VIEWED"
          productDisplay={{
            showName: false,
            showCollection: false,
            showPrice: false,
            showGems: false,
            showCuration: true,
          }}
        />
      </RevealSection>

      <Footer {...props} />
    </Box>
  );
};

export default ExportDefault;
